import React from 'react';
import { Box } from '@mui/material';
import { InfoHint } from '../../../../ui-kit';
import type { ReportTerm } from '../../../../types/reportDashboard';
import { termHint } from '../termHint';

/**
 * A name from the operations sheet's sheet, with what it counts behind an info icon. The icon is
 * yellow when it is a stand-in or not recorded, and says how it is worked out.
 */
export default function TermLabel({ term, strong }: { term: ReportTerm; strong?: boolean }) {
  const hint = termHint(term);
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap', fontWeight: strong ? 600 : undefined }}>
      {term.label}
      <InfoHint title={hint.title} label={`About ${term.label}`} tone={hint.tone} />
    </Box>
  );
}
